import { useLocalization } from '@/hooks/useLocalization';
import BotMessage from '@/components/ChatMessage/BotMessage';

export default function NameScreen() {
  const { t } = useLocalization();

  return (
    <BotMessage text={t('name.message')} />
  );
}
